import {TweenLite} from "gsap";

class Press {

    constructor(windowSizes) {
        this.windowSizes = windowSizes;

        this.duration = 1.5

        this.activeIndex = 0

        this.nav = document.querySelector('.section-press__nav')
        this.navItems = Array
            .prototype
            .slice
            .call(this.nav.querySelectorAll('.section-press__nav__item'), 0)
        this.container = document.querySelector('.section-press__inner')
    }

    init() {
        this
            .navItems
            .map((item, index) => {

                item.addEventListener('click', () => {
                    this.onNavClick(item, index)
                })
            })

        if (!this.windowSizes.mobileDevice) {
            this.loopNav()
        }

    }

    resize(windowSizes) {
        this.windowSizes = windowSizes;
    }

    disableAllNav() {
        this
            .navItems
            .map((item, index) => {
                item
                    .classList
                    .remove('section-press__nav__item--active')
            })
    }

    activeNavItem(item) {
        item
            .classList
            .add('section-press__nav__item--active')
    }

    moveContainer(index) {
        TweenLite.to(this.container, this.duration, {
            x: -this.windowSizes.width * index,
            ease: Quint.easeInOut,
            force3D: true
        })
    }

    onNavClick(item, index) {
        if (this.interval) {
            clearInterval(this.interval)
        }

        this.disableAllNav()
        this.activeNavItem(item)
        this.moveContainer(index)
    }

    loopNav() {

        this.interval = setInterval(() => {

            this.activeIndex = (this.activeIndex === this.navItems.length - 1)
                ? 0
                : this.activeIndex + 1;

            this.disableAllNav()
            this.activeNavItem(this.navItems[this.activeIndex])
            this.moveContainer(this.activeIndex)

        }, 5000)

    }

}

export default Press


// WEBPACK FOOTER //
// ./src/js/components/Press.js